import GlobalGrid from '../../../components/GlobalGrid';
import { ColorPicker, ColorPickerComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useContext, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import { ThemeContext } from '../../../context/theme.context';
var resultLikeQuery = '';
var theQuerySearch = '';
var the_current_query: string = '';
var searchText: string = '';
var colorElem: any;
var colorObj: any;
const SchedulerExeptions = () => {
  const [current_query, setCurrent_query] = useState('');
  const [loadSignal, setLoadSignal] = useState(false)
  const context = useContext(ThemeContext)
  const template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='scheduler_exeptions'
          autocomplete='off'
          input={inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            searchText = args.target.value;
          }}
        />
        {/* <div>
          <AiOutlineClose className={'searchCloseIcon'}  onClick={removeSearch.bind(this)} />
        </div> */}
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch color={context.isDarkMode ? '#eaeaea' : '#292525'} className={'searchIcon'} onClick={search.bind(this)} />
        </div>
      </div>
    );
  };
  const inputEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      search();
    }
  };
  const colorParams = {
    create: () => {
      colorElem = document.createElement('input');
      return colorElem;
    },
    destroy: () => {
      colorObj.destroy();
    },
    read: () => {
      return colorObj.value;
    },
    write: (args: any) => {
      colorObj = new ColorPicker({
        change: () => {},
        value: args.rowData.color,
      });
      colorObj.appendTo(colorElem);
    },
  };
  const theColumns = [
    {
      field: 'ID',
      textAlign: 'Left',
      isPrimaryKey: true,
      width: 40,
      allowEditing: false,
      visible:false
    },
    {
      field: 'name',
      headerText: 'Name',
      isPrimaryKey: true,
      allowEditing: true,
      width: 40,
    },
    {
      field: 'description',
      width: 40,
      headerText: 'Description',
      allowEditing: true,
    },
    {
      field: 'color',
      headerText: 'Color',
      textAlign: 'Left',
      allowEditing: true,
      width: 40,
      edit: colorParams,
      template:colorTemplate
    },
  ];
  const search = () => {
    if (searchText !== '' || current_query !== '') {
      resultLikeQuery = '';
      if (searchText !== '') {
        theColumns.map((el: any, index: number) => {
          if (el.field !== 'priority_code') {
            resultLikeQuery += `${el.field} like '%${searchText}%' `;
            if (index !== theColumns.length - 1) {
              resultLikeQuery += 'or ';
            }
          }
        });
        resultLikeQuery = resultLikeQuery.replaceAll("'%", '@@@');
      }
      buildQuery();
    }
  };
  const toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: template.bind(this), align: 'Right' },
  ];
  const buildQuery = () => {
    the_current_query = current_query;
    the_current_query = the_current_query.replace(the_current_query, '');

    if (resultLikeQuery !== '') {
      if (the_current_query !== '') {
        theQuerySearch = ' and (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      } else {
        theQuerySearch = ' (' + resultLikeQuery + ')';
        the_current_query = the_current_query + theQuerySearch;
      }
    }
    setCurrent_query(the_current_query);
    setLoadSignal(true);
  };
  function colorTemplate(args: any){
    return   <div
    style={{
      backgroundColor: args.color?args.color:"black",
      width: '15px',
      height: '15px',
      borderRadius: '20%',
      marginLeft: '10%',
    }}
  ></div>;
  }
  return (
    <div>
      <GlobalGrid
        columns={theColumns}
        height={'calc(-290px + 100vh)'}
        query={current_query}
        toolbarOptions={toolbarOptions}
        get_query={'scheduler-generals'}
        edit_query={'scheduler-generals/edit'}
        delete_query={'scheduler-generals/delete'}
        add_query={'scheduler-generals/create'}
        id={'-cost-grassetid'}
        signalOfLoad={true}
          
        primaryKeyName='ID'
      />
    </div>
  );
};

export default SchedulerExeptions;
